import React from "react"
import { Button, OverlayTrigger, Popover } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import Icon from "../common/icon/icon.component"
import "./ItemReportPopover.scss"
interface OwnProps {
    className: string
}

const ItemReportPopover = (props: OwnProps) => {
    return (
        <div className={props.className}>
            <OverlayTrigger
                trigger={["focus"]}
                placement="left"
                overlay={
                    <Popover id="item-report-popover">
                        <Popover.Title as="h5"> 
                            <FormattedMessage 
                                id="order.item-report-listing.warning-message-title"
                                defaultMessage="Item Report"
                            />
                        </Popover.Title> 
                        <Popover.Content> 
                            <FormattedMessage 
                                id="order.item-report-listing.warning-message"
                                defaultMessage="This report displays a maximum of 50 lines at a time.
                                If you don't see all the results you're looking for, you can adjust the filters options.
                                These filters can help you refine your search and find the specific information you need."
                            />
                        </Popover.Content> 
                    </Popover>}
            >
                <Button variant="warning" className="p-0 popover-round-button">
                    <Icon value="info" className="p-0" />
                </Button>
            </OverlayTrigger>
        </div>
    )
}

export default ItemReportPopover


// WEBPACK FOOTER //
// ./src/order/ItemReportPopover.tsx